import { QuestionCircleOutlined } from "@ant-design/icons";
import { Row, Space } from "antd";
import { Link } from "react-router-dom";
import GloabalConst from "../../common/GloabalConst";
import Prefixs from "../../common/Prefixs";
import ViewTutorialType from "../../common/ViewTutorialType";
import "./index.css";

const Header = () => {
  const viewTutorial = localStorage.getItem(GloabalConst.VIEW_TUTORIAL);

  return (
    <>
      {viewTutorial === ViewTutorialType.DISABLE ? (
        <></>
      ) : (
        <Row
          id="datidcaithehdsd"
          justify="end"
          align="middle"
          style={{ height: "var(--height-menu)" }}
        >
          <Link to={Prefixs.VIEW_FILE_TUTORIAL} target="_blank">
            <Space>
              <QuestionCircleOutlined />
              Hướng dẫn sử dụng
            </Space>
          </Link>
        </Row>
      )}
    </>
  );
};

export default Header;
